import React, { useState } from 'react';
import { THETEAM } from '@config/the-team';
import ImageSlider from './image-slider';
import Markup from '@root/src/common/markup/markup';
import SliderIndicator from '../projects/slider-indicator';

const TheTeam = () => {
    const [index, setIndex] = useState(1);
    return (
        <div className="pb-12 mx-4 md:mx-12 lg-mx-20 xl:mx-40 relative">
            <h2 className="About text-tan text-4xl md:text-6xl mb-4 font-kg-medium text-center">THE TEAM.</h2>
            <ImageSlider
                images={THETEAM}
                slidesToShow={3}
                setCurrentIndex={key => setIndex(key)}
                initialSlide={index}
            />
            <h3 className="text-lg text-center text-white my-4 lg:my-8 font-kg-medium">{THETEAM[index].name}</h3>
            <Markup
                className={
                    'markdown-body min-h-[350px] text-white lg:w-[60%] xl:w-[46%] mb-10 px-4 md:px-0 text-center lg:text-left text-xs md:text-base mx-auto '
                }
                content={THETEAM[index].description}
            />
            <div className="text-center">
                {THETEAM.map((member, key) => {
                    return (
                        <SliderIndicator
                            key={key}
                            index={key}
                            currentIndex={index}
                            onClick={() => {
                                return false;
                            }}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default TheTeam;
